export class Work {
    id: number
    comment: string
    spent_on: string
    hours: number
    project_id: number
    task_id: number
    work_type_id: number
    spent_on_for_input: string
}


/** WEBPACK FOOTER **
 ** ./src/app/service/work/work.ts
 **/